const getRequiredEnv = (name) => {
	const value = process.env[name];

	if (!value) {
		throw new Error(`${name} is not configured`);
	}

	return value;
};

const trimTrailingSlash = (value) => value.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(
	getRequiredEnv("REACT_APP_API_BASE_URL"),
);
const BUILD_TIME_FILE_BASE_URL = trimTrailingSlash(
	getRequiredEnv("REACT_APP_FILE_BASE_URL"),
);

const FILE_BASE_URL_STORAGE_KEY = "jerm.moderation.media-base-url";

const normalizeBaseUrl = (value) => {
	const trimmed = String(value ?? "").trim();
	if (!trimmed || !/^https?:\/\//i.test(trimmed)) {
		return null;
	}

	return trimTrailingSlash(trimmed);
};

// Where media lives is a backend setting (dbo.Config) now, so the admin keeps
// showing photos after they move to another host — without rebuilding this app.
// The build-time value remains the fallback, and the cached one is applied
// synchronously so the first render already points at the right host.
let runtimeFileBaseUrl = (() => {
	try {
		return normalizeBaseUrl(window.localStorage.getItem(FILE_BASE_URL_STORAGE_KEY));
	} catch {
		return null;
	}
})();

export const getFileBaseUrl = () => runtimeFileBaseUrl ?? BUILD_TIME_FILE_BASE_URL;

export const setFileBaseUrl = (value) => {
	const normalized = normalizeBaseUrl(value);
	if (!normalized || normalized === runtimeFileBaseUrl) {
		return;
	}

	runtimeFileBaseUrl = normalized;

	try {
		window.localStorage.setItem(FILE_BASE_URL_STORAGE_KEY, normalized);
	} catch {
		/* storage unavailable — only the cache is lost. */
	}
};

/**
 * Reads the address from the backend on start-up. Without this the admin only
 * learns it after someone opens Настройки, so a moderator on a fresh browser
 * would look at broken thumbnails everywhere else.
 *
 * Deliberately anonymous (GET /config/media) and best-effort: it runs before
 * login and must never block the app.
 */
export const refreshFileBaseUrl = async () => {
	try {
		const response = await fetch(`${API_BASE_URL}/config/media`);
		if (!response.ok) {
			return;
		}

		const data = await response.json();
		setFileBaseUrl(data?.baseUrl);
	} catch {
		/* offline or endpoint missing — keep the current address. */
	}
};
export const TELEGRAM_BASE_URL = trimTrailingSlash(
	getRequiredEnv("REACT_APP_TELEGRAM_BASE_URL"),
);
export const WORLD_ATLAS_URL = getRequiredEnv("REACT_APP_WORLD_ATLAS_URL");
